import React from "react";

const COMPARISON_DATA = [
    { label: "Replacements", us: "Unlimited replacements.", others: "Limited replacements." },
    { label: "Exclusions", us: "No exclusions.", others: "Excludes rips, tears, UV damage, and cracking." },
    { label: "Coverage", us: "Full coverage on arrival and throughout use.", others: "Coverage only applies to defects on arrival." },
    { label: "Ease of claim", us: "Simple and transparent process.", others: "Complicated process. Hidden fine print." },
    { label: "Value", us: "Unlimited protection.", others: "Less and less protection over time." },
];

const OurTablesVsOthers = () => {
    return (
        <div className="table-block table-block--our-tables-vs-others">
            <div className="table-block">
                <div className="table-block__header">
                    <div className="table-block__header-cell">Seal Skin Covers</div>
                    <div className="table-block__header-cell table-block__cell--pill">VS</div>
                    <div className="table-block__header-cell">Other Cover Brands</div>
                </div>

                {COMPARISON_DATA.map((row, index) => (
                    <div className="table-block__row" key={index}>
                        <div className="table-block__cell">{row.us}</div>
                        <div className="table-block__cell table-block__cell--pill">{row.label}</div>
                        <div className="table-block__cell">{row.others}</div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default OurTablesVsOthers;